import {
  exactEqualStringMatcher,
  exactFilterToValueMatcher,
} from '@/components/agGrid/AgGridHelperMethods'

export const getCustomAlertGridColumns = [
  {
    field: 'name',
    title: 'Name',
  },
  {
    field: 'dataSource',
    title: 'Data Source',
  },
  {
    field: 'airline',
    title: 'Airline',
  },
  {
    field: 'model',
    title: 'Model',
  },
  {
    field: 'active',
    title: 'Active',
  },
]

export const snapshotColumnDefs = [
  {
    headerName: '',
    field: '',
    width: 42,
    maxWidth: 42,
    resizable: false,
    checkboxSelection: true,
    suppressMovable: true,
    suppressSizeToFit: true,
  },
  {
    field: 'parameter',
    width: 395,
    filter: 'agTextColumnFilter',
    filterParams: {
      textMatcher: exactEqualStringMatcher,
    },
  },
  {
    field: 'rawName',
    width: 113,
    filter: 'agTextColumnFilter',
    filterParams: {
      textMatcher: exactEqualStringMatcher,
    },
  },
  {
    field: 'reportType',
    width: 135,
  },
  {
    field: 'system',
    filter: 'agTextColumnFilter',
    width: 101,
    filterParams: {
      textMatcher: exactFilterToValueMatcher,
    },
    floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
  },
  {
    field: 'airline',
    width: 88,
  },
  {
    field: 'model',
    filter: 'agTextColumnFilter',
    width: 83,
    filterParams: {
      textMatcher: exactFilterToValueMatcher,
    },
    floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
  },
  {
    headerName: 'unit',
    field: 'unit',
    filter: 'agTextColumnFilter',
    width: 83,
    filterParams: {
      textMatcher: exactFilterToValueMatcher,
    },
    floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
  },
]

export const fullFlightColumnDefs = [
  {
    headerName: '',
    field: '',
    width: 42,
    maxWidth: 42,
    resizable: false,
    checkboxSelection: true,
    suppressMovable: true,
    suppressSizeToFit: true,
  },
  {
    field: 'parameter',
    width: 441,
    filter: 'agTextColumnFilter',
    filterParams: {
      textMatcher: exactEqualStringMatcher,
    },
  },
  {
    field: 'rawName',
    width: 186,
    filter: 'agTextColumnFilter',
    filterParams: {
      textMatcher: exactEqualStringMatcher,
    },
  },
  {
    field: 'system',
    filter: 'agTextColumnFilter',
    width: 100,
    filterParams: {
      textMatcher: exactFilterToValueMatcher,
    },
    floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
  },
  {
    field: 'airline',
    width: 86,
  },
  {
    field: 'model',
    filter: 'agTextColumnFilter',
    width: 83,
    filterParams: {
      textMatcher: exactFilterToValueMatcher,
    },
    floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
  },
  {
    headerName: 'unit',
    field: 'unit',
    filter: 'agTextColumnFilter',
    width: 83,
    filterParams: {
      textMatcher: exactFilterToValueMatcher,
    },
    floatingFilterComponent: 'AscAgGridAutocompleteFloatFilter',
  },
]

export const buildSimpleAlertJson = ruleData => {
  return JSON.stringify(
    {
      type: 'and',
      persist: [
        ruleData.persistenceFrom === null ? '' : ruleData.persistenceFrom,
        ruleData.persistenceTo === null ? '' : ruleData.persistenceTo,
      ],
      flightPhases: ruleData.flightPhase,
      rules: [
        {
          type: 'simple',
          isEnabled:
            ruleData.isRangeMinEnabled === undefined
              ? false
              : ruleData.isRangeMinEnabled,
          parameter: ruleData?.parameterRawName,
          parameterId: ruleData?.parameterId,
          parameterName: ruleData.parameterName,
          op: '>',
          value:
            ruleData.minRange != null ? ruleData.minRange.toString() : null,
          name: 'rangeMin',
          isAlert: false,
        },
        {
          type: 'simple',
          isEnabled:
            ruleData.isRangeMaxEnabled === undefined
              ? false
              : ruleData.isRangeMaxEnabled,
          parameter: ruleData?.parameterRawName,
          parameterId: ruleData?.parameterId,
          parameterName: ruleData.parameterName,
          op: '<',
          value:
            ruleData.maxRange != null ? ruleData.maxRange.toString() : null,
          name: 'rangeMax',
          isAlert: false,
        },
        {
          type: 'or',
          isEnabled: true,
          rules: [
            {
              type: 'simple',
              isEnabled:
                ruleData.isHighWarningEnabled === undefined
                  ? false
                  : ruleData.isHighWarningEnabled,
              parameter: ruleData?.parameterRawName,
              parameterId: ruleData?.parameterId,
              parameterName: ruleData.parameterName,
              op: '>',
              value:
                ruleData.highWarning != null
                  ? ruleData.highWarning.toString()
                  : null,
              name: 'highWarning',
              isAlert: true,
            },
            {
              type: 'simple',
              isEnabled:
                ruleData.isLowWarningEnabled === undefined
                  ? false
                  : ruleData.isLowWarningEnabled,
              parameter: ruleData?.parameterRawName,
              parameterId: ruleData?.parameterId,
              parameterName: ruleData.parameterName,
              op: '<',
              value:
                ruleData.lowWarning != null
                  ? ruleData.lowWarning.toString()
                  : null,
              name: 'lowWarning',
              isAlert: true,
            },
            {
              type: 'simple',
              isEnabled:
                ruleData.isHighCautionEnabled === undefined
                  ? false
                  : ruleData.isHighCautionEnabled,
              parameter: ruleData?.parameterRawName,
              parameterId: ruleData?.parameterId,
              parameterName: ruleData.parameterName,
              op: '>',
              value:
                ruleData.highCaution != null
                  ? ruleData.highCaution.toString()
                  : null,
              name: 'highCaution',
              isAlert: true,
            },
            {
              type: 'simple',
              isEnabled:
                ruleData.isLowCautionEnabled === undefined
                  ? false
                  : ruleData.isLowCautionEnabled,
              parameter: ruleData?.parameterRawName,
              parameterId: ruleData?.parameterId,
              parameterName: ruleData.parameterName,
              op: '<',
              value:
                ruleData.lowCaution != null
                  ? ruleData.lowCaution.toString()
                  : null,
              name: 'lowCaution',
              isAlert: true,
            },
          ],
        },
      ],
    },
    replacer,
  )
}

const advCustomExpOptions = [
  {
    text: 'AND',
    value: 'AND',
    icon: false,
    isOperation: true,
    color: 'success',
    order: 1,
  },
  {
    text: 'ABS',
    value: 'ABS',
    icon: false,
    isOperation: true,
    allowAtStart: true,
    isFunction: true,
    color: 'purple',
    order: 2,
  },
  {
    text: '*',
    value: '*',
    alt: '',
    isOperator: true,
    color: 'blue',
    order: 3,
  },
  {
    text: '—',
    value: '-',
    alt: '—',
    isOperator: true,
    color: 'blue',
    order: 4,
  },
  {
    text: '>',
    value: '>',
    isOperator: true,
    alt: '&gt;',
    color: 'magenta',
    order: 5,
  },
  {
    text: '<',
    value: '<',
    isOperator: true,
    alt: '&lt;',
    color: 'magenta',
    order: 6,
  },
  {
    text: 'OR',
    value: 'OR',
    icon: false,
    isOperation: true,
    color: 'success',
    order: 7,
  },
  {
    text: 'ROUND',
    value: 'Round',
    icon: false,
    isOperation: true,
    allowAtStart: true,
    isFunction: true,
    color: 'purple',
    order: 8,
  },
  {
    text: '/',
    value: '/',
    isOperator: true,
    alt: '',
    color: 'blue',
    order: 9,
  },
  {
    text: '+',
    value: '+',
    isOperator: true,
    alt: '',
    color: 'blue',
    order: 10,
  },
  {
    text: '>=',
    value: '>=',
    isOperator: true,
    alt: '&gt;=',
    color: 'magenta',
    order: 11,
  },
  {
    text: '<=',
    value: '<=',
    isOperator: true,
    alt: '&lt;=',
    color: 'magenta',
    order: 12,
  },
  {
    text: 'WHERE',
    value: 'WHERE',
    icon: false,
    isOperation: true,
    color: 'success',
    order: 13,
  },
  {
    text: '"',
    value: '"',
    isOperator: true,
    alt: '',
    color: 'caution',
    order: 14,
  },
  {
    text: '.',
    value: '.',
    isOperator: true,
    alt: '',
    color: 'accent',
    order: 15,
  },
  {
    text: '(',
    value: '(',
    isOperator: true,
    allowAtStart: true,
    alt: '',
    color: 'accent',
    order: 16,
  },
  {
    text: ')',
    value: ')',
    isOperator: true,
    alt: '',
    color: 'accent',
    order: 17,
  },
  {
    text: '[',
    value: '[',
    isOperator: true,
    allowAtStart: true,
    alt: '',
    color: 'yellow',
    order: 18,
  },
  {
    text: ']',
    value: ']',
    isOperator: true,
    alt: '',
    color: 'yellow',
    order: 19,
  },
  {
    text: '!=',
    value: '!=',
    isOperator: true,
    alt: '',
    color: 'red',
    order: 20,
  },
  {
    text: '=',
    value: '=',
    isOperator: true,
    alt: '',
    color: 'red',
    order: 21,
  },
]

const allowedAdvCustomExpInputs = {
  '*': 56,
  '-': 189,
  '>': 190,
  '<': 188,
  '/': 191,
  '=': 187,
  '+': 187, // same keycode for = , string is matched not keycode
  '"': 222,
  '.': 190,
  '(': 57,
  ')': 48,
  '[': 219,
  ']': 221,
  '!': 49,
  _: 189,
  ',': 188,
  // '#' : 51
}

export const getAdvCustomExpOptions = (isNotAdvancedAcmf = false) => {
  return isNotAdvancedAcmf
    ? advCustomExpOptions
    : advCustomExpOptions.filter(item => item.value.toLowerCase() !== 'where')
}

export const getAllowedAdvCustomExpInputs = () => {
  return allowedAdvCustomExpInputs
}

const derivedParametrsExpOptions = [
  {
    text: 'ABS',
    value: 'ABS',
    icon: false,
    isOperation: true,
    allowAtStart: true,
    isFunction: true,
    color: 'purple',
    order: 2,
  },
  {
    text: '*',
    value: '*',
    alt: '',
    isOperator: true,
    color: 'blue',
    order: 3,
  },
  {
    text: '—',
    value: '-',
    alt: '—',
    isOperator: true,
    color: 'blue',
    order: 4,
  },
  {
    text: '(',
    value: '(',
    isOperator: true,
    allowAtStart: true,
    alt: '',
    color: 'accent',
    order: 16,
  },
  {
    text: ')',
    value: ')',
    isOperator: true,
    alt: '',
    color: 'accent',
    order: 17,
  },
  {
    text: 'ROUND',
    value: 'Round',
    icon: false,
    isOperation: true,
    allowAtStart: true,
    isFunction: true,
    color: 'purple',
    order: 8,
  },
  {
    text: '/',
    value: '/',
    isOperator: true,
    alt: '',
    color: 'blue',
    order: 9,
  },
  {
    text: '+',
    value: '+',
    isOperator: true,
    alt: '',
    color: 'blue',
    order: 10,
  },
  {
    text: '[',
    value: '[',
    isOperator: true,
    allowAtStart: true,
    alt: '',
    color: 'yellow',
    order: 18,
  },
  {
    text: ']',
    value: ']',
    isOperator: true,
    alt: '',
    color: 'yellow',
    order: 19,
  },
]

const allowedDerivedParameterExpInputs = {
  '*': 56,
  '-': 189,
  '/': 191,
  '+': 187,
  '(': 57,
  ')': 48,
  '[': 219,
  ']': 221,
  _: 189,
  // '#' : 51
}

export const getDerivedParametersExpOptions = () => {
  return derivedParametrsExpOptions
}

export const getAllowedDerivedParameterExpInputs = () => {
  return allowedDerivedParameterExpInputs
}

export const buildAdvancedAlertJson = ruleData => {
  return JSON.stringify(
    {
      configurationType: ruleData.configurationType,
      persist:
        ruleData.persistenceFrom && ruleData.persistenceTo
          ? [ruleData.persistenceFrom, ruleData.persistenceTo]
          : null,
      aggregateDays: ruleData.aggregateDays ? ruleData.aggregateDays : null,
      aggregateReports: ruleData.aggregateReports
        ? ruleData.aggregateReports
        : null,
      flightPhases: ruleData.flightPhase, // Flight phases will be null for acmf
      severityLevel: ruleData.severityLevel,
      type: 'expression',
      value: ruleData.expression ? ruleData.expression : '',
      validLogic: ruleData.validLogic ? ruleData.validLogic : false,
      isLookbackValid: ruleData.isLookbackValid
        ? ruleData.isLookbackValid
        : false,
    },
    replacer,
  )
}

export const parseSimpleAlertJson = ruleJson => {
  // parse JSON rule definition to get the other pieces of the
  // custom alert.  We parse them to make them easier to manipulate
  // on the front end.  They get stored as JSON
  const alertObj = {}
  const parsedCustomAlertJSON = JSON.parse(ruleJson)
  alertObj.persistenceFrom = parsedCustomAlertJSON.persist[0]
  alertObj.persistenceTo = parsedCustomAlertJSON.persist[1]
  alertObj.flightPhase = parsedCustomAlertJSON.flightPhases
  parsedCustomAlertJSON.rules.forEach(ruleObj => {
    if (ruleObj.name === 'rangeMin') {
      alertObj.parameterId = ruleObj?.parameterId
      alertObj.parameterRawName = ruleObj?.parameter
      alertObj.parameterName = ruleObj?.parameterName
      alertObj.minRange = ruleObj.value === null ? null : Number(ruleObj.value)
      alertObj.isRangeMinEnabled =
        ruleObj.isEnabled === null ? false : ruleObj.isEnabled
    } else if (ruleObj.name === 'rangeMax') {
      alertObj.maxRange = ruleObj.value === null ? null : Number(ruleObj.value)
      alertObj.isRangeMaxEnabled = ruleObj.isEnabled
    } else if (ruleObj.rules) {
      ruleObj.rules.forEach(subRuleObj => {
        if (subRuleObj.name === 'highWarning') {
          alertObj.highWarning =
            subRuleObj.value === null ? null : Number(subRuleObj.value)
          alertObj.isHighWarningEnabled = subRuleObj.isEnabled
        } else if (subRuleObj.name === 'lowWarning') {
          alertObj.lowWarning =
            subRuleObj.value === null ? null : Number(subRuleObj.value)
          alertObj.isLowWarningEnabled = subRuleObj.isEnabled
        } else if (subRuleObj.name === 'highCaution') {
          alertObj.highCaution =
            subRuleObj.value === null ? null : Number(subRuleObj.value)
          alertObj.isHighCautionEnabled = subRuleObj.isEnabled
        } else if (subRuleObj.name === 'lowCaution') {
          alertObj.lowCaution =
            subRuleObj.value === null ? null : Number(subRuleObj.value)
          alertObj.isLowCautionEnabled = subRuleObj.isEnabled
        }
      })
    }
  })
  return alertObj
}

const updateExpression = value => {
  const derivedParamsRegEx = /\[dp_.*?\]/gi
  const derviedParameters = (value || '').match(derivedParamsRegEx) || []

  if (derviedParameters.length) {
    return value.replace(derivedParamsRegEx, function (derivedParam) {
      const paramString = derivedParam.match(/\[(.*?)\]/)[1]
      return `[${paramString.split(':')[0]}]`
    })
  }
  return value
}

export const parseAdvancedAlertJson = ruleJson => {
  const alertObj = {}
  const parsedCustomAlertJSON = JSON.parse(ruleJson)
  alertObj.configurationType = parsedCustomAlertJSON.configurationType
    ? parsedCustomAlertJSON.configurationType
    : 'persistence'
  alertObj.persistenceFrom = parsedCustomAlertJSON.persist
    ? parsedCustomAlertJSON.persist[0]
    : null
  alertObj.persistenceTo = parsedCustomAlertJSON.persist
    ? parsedCustomAlertJSON.persist[1]
    : null
  alertObj.aggregateDays = parsedCustomAlertJSON.aggregateDays
  alertObj.aggregateReports = parsedCustomAlertJSON.aggregateReports
  alertObj.flightPhase = parsedCustomAlertJSON.flightPhases
  alertObj.severityLevel = parsedCustomAlertJSON.severityLevel
  alertObj.type = parsedCustomAlertJSON.type
  alertObj.expression = parsedCustomAlertJSON.value
    ? updateExpression(parsedCustomAlertJSON.value)
    : ''
  alertObj.validLogic = parsedCustomAlertJSON.validLogic
    ? parsedCustomAlertJSON.validLogic
    : false
  alertObj.isLookbackValid = parsedCustomAlertJSON.isLookbackValid

  return alertObj
}

export const isCustomAlertTypeIncludes = (match, id, alertArray) => {
  if (!match || !id || !alertArray.length) return false
  const matchedAlert = alertArray.filter(alert => alert.id === id)
  return matchedAlert[0].name.includes(match)
}

export const isValidRecAction = recAction => {
  const emptyLine = '<p></p>'
  const nonEmptyLines = recAction?.replace(/\s/g, '').replaceAll(emptyLine, '')
  return nonEmptyLines?.length > 0
}

const replacer = (key, value) => (typeof value === 'undefined' ? null : value)
